import type { OsVersionResourceReadV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { OsVersionResource } from '../../../models/osVersion.model';

export function mapOsVersionByIdApi({
  artifacts,
  creationDate,
  id,
  longDescription,
  osId,
  publisherId,
  shortDescription,
  status,
  versionNumber,
}: OsVersionResourceReadV2Api): OsVersionResource {
  return {
    artifacts,
    creationDate,
    id,
    longDescription,
    osId,
    publisherId,
    shortDescription,
    status,
    versionNumber,
  };
}
